<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><span><a href="#/toc#toc-chapter003">THREE</a></span></h1>
<p class="noindent"><a id="page-9">‘You’re late.’</a></p><a id="page-9">
<p>‘I am.’</p>
<p>‘I think you should try and be on time.’</p>
<p>‘I did try.’</p>
<p>‘Could you try harder?’</p>
<p>‘Sure I could.’</p>
<p>‘So take a seat, Frank … tell me what happened this morning?’</p>
<p>‘You can read my report.’</p>
<p>‘I want to hear it in your own words.’</p>
<p>‘I wrote the report. Those <em>are</em> my own words.’</p>
<p>‘You know what I mean, Frank. I want to hear you tell me what happened.’</p>
<p>‘He cut his girlfriend’s throat. He cut his own throat. There was so much fucking blood it was like a water slide at Tomahawk Lake or something. How’s that for you?’</p>
<p>‘Tell me from the beginning, Frank. From the point you got the call about how he was holding the girl hostage.’</p>
<p>‘No.’</p>
<p>‘Why not?’</p>
<p>‘Because I can’t be bothered, that’s why. Jesus, what the fuck <em>is</em> this?’</p>
<p>‘This is therapeutic counselling, designed to help you deal with the stress of your job and make you feel better. You know that.’</p>
<p>‘You want to make me feel better?’</p>
<p>‘Sure. That’s what I’m here for.’</p>
<p>‘Then come over here and take care of me.’</p>
<p>‘No, Frank, I am not going to come over there and take care of you.’</p>
<p>‘You married?’</p>
<p>‘Is that important?’</p>
</a><p><a id="page-9"></a><a id="page-10">‘Maybe … I’m just thinking … you got no wedding band, but maybe you just don’t wear it ’cause you kinda like burned-out alcoholic cops hitting on you.’</a></p><a id="page-10">
<p>‘No, Frank. I don’t wear one because I’m not married.’</p>
<p>‘Well, how ’bout that! I ain’t married neither. So what say I come down here to your cozy little office, we draw the blinds … you know how it is. That’s the kinda stress counselling I could really use right now.’</p>
<p>‘Is that what you feel?’</p>
<p>‘Damn right it’s what I feel. And I bet you do too, <em>Doctor.</em> If only it wasn’t for professional ethics, eh?’</p>
<p>‘Whatever you say, Frank.’</p>
<p>‘Now we’re talking.’</p>
<p>‘No, Frank, I don’t think we’re talking at all. You’re trying to offend me, and I’m humoring you.’</p>
<p>‘Is that what you think I’m doing? Saying shit that will offend you?’</p>
<p>‘I do think that. You’re trying to shock me. That stuff about coming over to take care of you, for example.’</p>
<p>‘No, Ma’am, that’s how I go about courting someone.’</p>
<p>‘Well, if that’s true, then I figure we’re all pretty much safe from the charms of Frank Parrish.’</p>
<p>‘That’s funny. Now you’re trying to make me laugh.’</p>
<p>‘No, I’m not. But I <em>am</em> trying to give you an opportunity to release some of the stress and trauma that goes with your particular line of work.’</p>
<p>‘Oh, shee-it. Save it for the rookies and the faggots and the female officers.’</p>
<p>‘That’s a very slanted viewpoint.’</p>
<p>‘Hey, lady, it’s a very fucking slanted world.’</p>
<p>‘So you don’t want to talk about Tommy Scott and Heather Wallace.’</p>
<p>‘That a question or a statement?’</p>
<p>‘Whichever.’</p>
<p>‘No, I don’t want to talk about Tommy Scott and Heather Wallace. What the fuck use would that be?’</p>
<p>‘Sometimes people need to talk.’</p>
<p>‘Sometimes people need to have other people urinate all over them. Don’t mean it does ’em any good.’</p>
<p>‘Why do you think you’re doing this, Frank?’</p>
</a><p><a id="page-10"></a><a id="page-11">‘What?’</a></p><a id="page-11">
<p>‘Trying to offend me.’</p>
<p>‘Lordy, lordy, little girl, you <em>have</em> led a sheltered life. You think that’s so offensive? Hell, you should hear what I say to members of the general public.’</p>
<p>‘I’ve heard about some of those things.’</p>
<p>‘Well, this is me being polite, okay? On my best behavior.’</p>
<p>‘Well, your <em>best behavior</em> has gotten you eleven verbal cautions, two written warnings, your driver’s license suspended, and a one-third pay hold until Christmas. Oh yes – and a recommendation that you see me on a regular basis until your attitude improves.’</p>
<p>‘And you think it’ll do me some good? Coming on down here and talking to you?’</p>
<p>‘I hope so.’</p>
<p>‘Why?’</p>
<p>‘Because it’s what I do, Frank. It’s my job, my purpose.’</p>
<p>‘And you’re a shrink, right?’</p>
<p>‘I am a psychotherapist.’</p>
<p>‘Psycho-the-rapist.’</p>
<p>‘No, Frank, a psychotherapist.’</p>
<p>‘I’ve met a few rapist psychos in my time.’</p>
<p>‘I know.’</p>
<p>‘You <em>know?’</em></p>
<p>‘Yes, Frank, I know some of the people you’ve had to deal with. I know about some of the things that you’ve seen.’</p>
<p>‘And what does that tell you?’</p>
<p>‘It tells me that you’re a troubled man. That you might need someone to talk to.’</p>
<p>‘Am I that obvious?’</p>
<p>Well, yes, I think you are, Frank. I think you are that obvious.’</p>
<p>‘You wanna know something we were taught in the Keystone Kops?’</p>
<p>‘Sure.’</p>
<p>‘Sometimes the obvious occludes the truth. And sometimes things are exactly as they appear.’</p>
<p>‘Meaning what?’</p>
</a><p><a id="page-11">‘Well, it’s real simple. I <em>appear</em> to be an aggressive, fucked-up, alcoholic loser with some twenty years on the career </a><a id="page-12">clock … and you can throw into that incendiary mix my dangerously low self-esteem and a taste for cheap women and expensive whiskey, and you wind up with someone that you really don’t want to get involved with. And like I said, even though that is only who I <em>appear</em> to be, I think you’re gonna find out it’s exactly who I am.’</a></p><a id="page-12">
<p>‘Well, it looks like we’re going to be spending a few really interesting weeks together.’</p>
<p>‘You’re worried I’m gonna go crazy, aren’t you?’</p>
<p>‘I don’t like to use that term.’</p>
<p>‘Oh for God’s sake, when did everyone start getting so goddamn scared of words? It’s just a <em>word</em>, okay? Just a fucking word. Crazy. Crazy. <em>Crazy.’</em></p>
<p>‘Okay, so I’m worried that you might go crazy.’</p>
<p>‘Some people never go crazy. What truly horrible lives they must lead.’</p>
<p>‘You think that?’</p>
<p>‘Bukowski said it. You know Charles Bukowski?’</p>
<p>‘He was a drunk, I believe.’</p>
<p>‘He was a writer. A writer. Like I am a cop, like you are psycho-the-rapist. The booze doesn’t define us lady, it augments the already rich fullness of our lives.’</p>
<p>‘You are so full of shit, Frank Parrish.’</p>
<p>‘Are you actually allowed to say that to me? Doesn’t your professional ethical code prevent you from telling me that I am full of shit?’</p>
<p>‘Go home and get some sleep, Frank. Come back and talk to me when you’re in a better mood.’</p>
<p>‘Hey, that might just be never, Doctor Griffin.’</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter003.vue?73595541